export default __webpack_public_path__ + "static/media/leaf3.f71c1453.png";